let NavigationFactory = function ($state, DataCounter, Configs, CommonLayoutService) {
    let permissions = null;

    const goToServiceHistory = function (locationId, date, isRedirected, modal) {
        if (modal) modal.close();
        const obj = {
            locationId: locationId,
            vaultDate: date,
            isRedirected: isRedirected
        }
        DataCounter.setData(obj);
        $state.go('branchManagement.locations');
    }

    const goToItemHistory = function (trackingId, modal) {
        if (modal) modal.close();
        $state.go('branchManagement.items', {
            id: trackingId,
        });
    }

    const goToOrderHistory = function (orderNo, date, isRedirected, isCounted, isInProcess, isPending, modal, fundingSourceId = null) {
        if (modal) modal.close();
        const obj = {
            orderNo: orderNo,
            vaultDate: date,
            isRedirected: isRedirected,
            isCounted: isCounted,
            isInProcess: isInProcess,
            isPending: isPending,
            fundingSourceId: fundingSourceId
        }
        DataCounter.setData(obj);
        $state.go('branchManagement.orders');
    }

    const goToRouteTab = function (routeId, date, isRedirected, modal) {
        if (modal) modal.close();
        const obj = {
            routeId: routeId,
            vaultDate: date,
            isRedirected: isRedirected
        }
        DataCounter.setData(obj);
        $state.go('branchManagement.routes');
    }

    const goToAtmCount = function (trackingId, isRedirected, modal, fundingSourceId = null) {
        if (modal) modal.close();
        const obj = {
            trackingId: trackingId,
            isRedirected: isRedirected,
            fundingSourceId: fundingSourceId
        }
        DataCounter.setData(obj);
        $state.go('atmCount');
    }

    const goToOrderPack = function (routeId, date, locationId, isRedirected, orderNo, isEC, modal) {
        if (modal) modal.close();
        const obj = {
            routeId: routeId,
            vaultDate: date,
            locationId: locationId,
            isRedirected: isRedirected,
            orderNo: orderNo,
            isEC: isEC
        }
        DataCounter.setData(obj);
        $state.go('orderPacking');
    }

    const goToOrderPackingFromLocation = function (locationId, orderNo, fundingSourceId, modal) {
        if (modal) modal.close();
        const obj = {
            locationId: locationId,
            orderNo: orderNo,
            fundingSourceId: fundingSourceId,
            isRedirected: true
        }
        DataCounter.setData(obj);
        $state.go('orderPacking');
    }

    const goToItemHold = function (trackingId, isRedirected) {
        const obj = {
            trackingId: trackingId,
            isRedirected: isRedirected
        }
        DataCounter.setData(obj);
        $state.go('branchManagement.itemHolds');
    }

    const goToUserTab = function (userId, modal) {
        permissions = Configs.getPermissionConfig();
        if (!permissions.hasSettingsPermission && !CommonLayoutService.isAllowToAccessPages() || !permissions.hasUserEditPermission && !CommonLayoutService.isAllowToAccessPages() ) return;

        if (modal) modal.close();
        $state.go('users.edit', {
            id: userId,
        });
    }

    const goToVehicleTab = function (vehicleId, modal) {
        permissions = Configs.getPermissionConfig();
        if (!permissions.hasSettingsPermission  && !CommonLayoutService.isAllowToAccessPages()) return;

        if (modal) modal.close();
        $state.go('truck.edit', {
            id: vehicleId,
        });
    }

    const goToLocationTab = function (locationId, modal) {
        permissions = Configs.getPermissionConfig();
        if (!permissions.hasSettingsPermission  && !CommonLayoutService.isAllowToAccessPages()) return;

        if (modal) modal.close();
        $state.go('location.edit', { id: locationId });
    }

    const goToSettingsRouteTab = function (route, selectedDay) {
        permissions = Configs.getPermissionConfig();
        if (!permissions.hasSettingsPermission  && !CommonLayoutService.isAllowToAccessPages()) return;

        $state.go('routes.edit', { id: route, day: selectedDay });
    }

    const goToAllLocationTab = function (modal) {
        permissions = Configs.getPermissionConfig();
        if (!permissions.hasSettingsPermission  && !CommonLayoutService.isAllowToAccessPages()) return;

        if (modal) modal.close();
        $state.go('location.all', { page: 1 });
    }

    const goToServiceTicket = function (encounterId, modal) {
      if (modal) modal.close()
      const obj = { encounterId }
      DataCounter.setData(obj)
      $state.go('serviceTickets')
    }

    return {
        goToServiceHistory,
        goToItemHistory,
        goToOrderHistory,
        goToRouteTab,
        goToAtmCount,
        goToOrderPack,
        goToOrderPackingFromLocation,
        goToItemHold,
        goToUserTab,
        goToVehicleTab,
        goToLocationTab,
        goToSettingsRouteTab,
        goToAllLocationTab,
        goToServiceTicket
    }
}

NavigationFactory.$inject = ['$state', 'DataCounter', 'Configs', 'CommonLayoutService'];

export default NavigationFactory;



// WEBPACK FOOTER //
// ./client/app/common/navigation/navigation.factory.js